(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hgcr-sim-handoff"] && !Shopify.designMode) return;
  try {
    (function(){
  var dialog=document.getElementById('hgcr-sim-handoff');
  if(!dialog || !dialog.showModal) return;
  var opener;
  document.addEventListener('click',function(event){
    var link=event.target.closest('a[data-hgcr-sim]');
    if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
    event.preventDefault();
    opener=link;
    dialog.showModal();
  });
  dialog.querySelector('.hgcr-sim__close').addEventListener('click',function(){dialog.close();});
  dialog.addEventListener('click',function(event){
    if(event.target!==dialog) return;
    var r=dialog.getBoundingClientRect();
    if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) dialog.close();
  });
  dialog.addEventListener('close',function(){if(opener) opener.focus();});
})();
  } catch(e) { console.error(e); }
})();

})();
